import React, { PropTypes, PureComponent } from 'react';
import validate from 'validate.js';
import { FormControl, FormHelperText } from 'material-ui/Form';
import Input, { InputLabel, InputAdornment } from 'material-ui/Input';
import IconButton from 'material-ui/IconButton';
import Visibility from 'material-ui-icons/Visibility';
import VisibilityOff from 'material-ui-icons/VisibilityOff';

class PasswordField extends PureComponent {
  constructor() {
    super();

    this.state = {
      showPassword: false,
    };
  };

  handlePasswordVisibility = () => {
    this.setState({showPassword: !this.state.showPassword});
  };

  render() {
    const {
      field_name,
      value,
      onChange,
      className,
      label,
      errors,
      autoComplete = 'on',
    } = this.props;
    const {showPassword} = this.state;

    return (
      <div className={`${className}`}>
        <FormControl style={{ width: '100%', marginBottom: '15px', marginTop: '20px' }}>
          <InputLabel error={(errors && errors.length)} htmlFor={field_name}>{label}</InputLabel>
          <Input
            error={(errors && errors.length)}
            id={field_name}
            name={field_name}
            type={showPassword ? 'text' : 'password'}
            value={value}
            onChange={onChange}
            endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="Toggle password visibility"
                    onClick={this.handlePasswordVisibility}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
            />
            <FormHelperText id="weight-helper-text" error={(errors && errors.length)}>
              {(errors || [])[0]}
            </FormHelperText>
          </FormControl>
      </div>
    )
  }
}

PasswordField.propTypes = {
  field_name: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  errors: PropTypes.oneOfType([
    PropTypes.array,
    null
  ]),
  autoComplete: PropTypes.string,
  showPassword: PropTypes.bool,
  onPasswordChangeVisibility: PropTypes.func
}

export default PasswordField;



// WEBPACK FOOTER //
// ./src/components/InputField/PasswordField.jsx